export enum CompanyMemberRole {
    VIEWER = "VIEWER",
    EDITOR = "EDITOR",
    MANAGER = "MANAGER",
}

export type CompanyMemberSecurityAttributes = Partial<Record<string, boolean>>;

export interface CompanyMember {
    companyId: string;
    userId: string;
    role: CompanyMemberRole;
    attributes: CompanyMemberSecurityAttributes;
}

export interface CompanyMemberEx extends CompanyMember {
    companyName: string;
    userName: string;
    userEmail: string;
    isAdvanced: boolean;
    lastActivity?: Date;
}
